import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getDependentSummary } from "../../../../store/Api";
export default function ApplyInsurance_InsuranceDependent({
  token,
  titles = [],
  list = [],
  loading,
}) {
  const [subIndex, setsubIndex] = useState(1);
  const [searchWords, setSearchWords] = React.useState([]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  function handleClickSubIndex(numb) {
    setsubIndex(numb);
  }
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/downloadDependentSummary`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `DependentSummary`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const formatDate = (dateString) => {
    // Create a new Date object from the given dateString
    const date = new Date(dateString);

    // Check if the date object is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    // Define an array of month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the individual components of the date
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Construct the desired format
    const formattedDate = `${day}-${monthName.toLowerCase()}-${year}`;

    return formattedDate;
  };

  return (
    <div>
      {/* more tabs */}

      <div className="mt-2 flex ">
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${subIndex == 1 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => handleClickSubIndex(1)}
        >
          Pending List
        </button>
        <button
          className={`p-3 m-2 h-10  uppercase text-xs mr-4 rounded-md ${subIndex == 2 ? "bg-red text-white" : "bg-[#BFBFBF] text-black"}`}
          onClick={() => handleClickSubIndex(2)}
        >
          Applied List
        </button>
      </div>

      {/* search bar and button */}

      <div className="flex justify-between">
        <div className="flex gap-x-4 items-center">
          <Search
            searchKey={[
              "employee_id",
              "visa_reference_number",
              "border_number",
              "iqama_number",
              "client_id",
              "emp_id",
              "sponsor_id",
            ]}
            setSearchWords={setSearchWords}
          />
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[35px]"
            onClick={() => downloadFile()}
          >
            DOWNLOAD
          </button>
        </div>
        <div>
          {subIndex === 1 ? (
            <button className="bg-red text-white px-4 rounded-md py-2 text-sm h-[36px]">
              DOWNLOAD APPLICATION
            </button>
          ) : (
            <div className="flex gap-x-2">
              <button className="bg-red text-white px-4 rounded-md py-2 text-sm h-[36px]">
                DOWNLOAD INSURANCE DATA TEMPLATE
              </button>
              <button className="bg-red text-white px-4 rounded-md py-2 text-sm h-[36px]">
                UPLOAD INSURANCE DATA
              </button>
            </div>
          )}
        </div>
      </div>
      {/* table */}
      <div
        className={`grid grid-cols-table-workflow-applyInsurance auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md mt-8`}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {list?.isLoading && <LoadingWithLable className="col-span-6" />}
        {!list?.isLoading && <NoDataFound />}

        {!list?.isLoading
          ? currentList?.map((list, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list?.dependent_name || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={formatDate(list.dependent_dob) || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.relation || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.class || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.client_id || "-"}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.dependent_gender || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.headOfFamily || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.insuranceApplyDate || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.delayedDays || "-"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.status || "-"}
                  />
                </p>

                <hr
                  className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                />
              </React.Fragment>
            ))
          : ""}
      </div>

      <Pagination />
    </div>
  );
}
